import React from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {usePermission} from "../../../Hooks/PermissionHooks";

export const FileVisibilityHelper = (props) => {
    let visibilityText, visibilityIcon;
    
    const permission = usePermission();
    if(!permission('update_file')) {
        return null;
    }

    if (props.file?.publicVisibility && props.file?.auditorVisibility) {
        visibilityText = `Visible to public due to: ${props.file.publicVisibility}`;
        visibilityIcon = 'users';
    } else if (props.file?.auditorVisibility) {
        visibilityText = `Visible to auditors due to: ${props.file.auditorVisibility}`;
        visibilityIcon = 'user-unlock';
    }

    if (!visibilityText) {
        return null;
    }

    return <OverlayTrigger
        key="right"
        placement="right"
        overlay={
            <Tooltip id={`file-browser-tooltip-${props.file?.fileUploadId}`}>
                {visibilityText}
            </Tooltip>
        }
        rootClose
    >
        <FontAwesomeIcon icon={['fas', visibilityIcon]} className="help-icon" />
    </OverlayTrigger>
};



